import React, { useState } from "react";
import {
  Badge,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Container, Row, Col, Collapse, Button } from "reactstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import {
  CUSTOM_QUESTION_INPUT_TYPES,
  getSourceStringfromQuestion,
  THEME_SETTING,
} from "../data";
import parse from "react-html-parser";
import RangeInput from "../../../components/RangeInput/RangeInput";
import AccordionCommon from "../../../components/AccordionCommon/Accordion"

export default function QuestionsListModal({ currentTrivia, open, onClose }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleCollapse = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const formatAlignText = (text)=>{
    const cleanPText = text.replaceAll("<p>","").replaceAll("</p>","");

    return parse(cleanPText);
  }
  return (
    <Modal isOpen={open} className="bwai-edit-modal bwai-edit-qlist-modal">
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
        Questions (List view)
      </ModalHeader>
      <ModalBody className="p-3">
        <h5 className="text-center">{parse(currentTrivia.name || "")}</h5>

        <hr className="my-4" />

        {currentTrivia.questions.map((question, index) => {
          const qTypeLable = CUSTOM_QUESTION_INPUT_TYPES.find(
            (x) => x.value === question.question_type
          );
          return (
            <div key={index} className="question_list_view_text mt-3 mb-3">
              <div className="">
               <div className="d-flex">
                 <h5>{index + 1}. {formatAlignText(question.question_text)}</h5> 
                </div> <div>
                {question.question_type == "LINEAR_NUMERIC" && (
                  <div className="my-2">
                    {question.linearNumericConfigs &&
                    question.linearNumericConfigs.min &&
                    question.linearNumericConfigs.max ? (
                      <span>
                        Give answer in range of{" "}
                        {question.linearNumericConfigs.min} -{" "}
                        {question.linearNumericConfigs.max}{" "}
                      </span>
                    ) : (
                      " Give answer"
                    )}
                  </div>
                )}

                {question.question_type === "LINEAR_NUMERIC" ? (
                  <div className="mt-4">
                    <RangeInput
                      min={question.linearNumericConfigs.min}
                      max={question.linearNumericConfigs.max}
                      value={null}
                      onChange={(value) => {}}
                      themeSettings={
                        {
                          quizTextColor:"black",
                          quizBackgroundColor:"white"
                        }
                      }
                      numberColor="black"
                    />
                  </div>
                ) : question.question_type === "TEXT" ? (
                  <div className="mt-4">
                    <Input type="textarea" rows={2} />
                  </div>
                ) : question.question_type === "MCQ" ? (
                  <div className="mt-4">
                   <b>Options:</b> 
                    <Row className="mx-0 px-1">
                      {question.options &&
                        question.options.length &&
                        question.options.map((option, idx) => {
                          return (
                            <Col className="my-2" md={6} sm={12}>
                              {" "}
                            
                             <b>{idx + 1})</b>  {formatAlignText(option.text)}{" "}
                            </Col>
                          );
                        })}
                    </Row>

                    {question.correct_options && question.correct_options[0] ? (
                      <div className="my-3">
                       <b>Answer:</b>  {formatAlignText(question.correct_options[0].text)}
                      </div>
                    ) : (
                      ""
                    )}


                    <div className="my-3">
                      {question.source && getSourceStringfromQuestion(question) ? <b>Source: </b> :""}
                      {!question.isSourceRemoved
                        ? getSourceStringfromQuestion(question)
                        : "No source"}
                    </div>
                  </div>
                ) : question.question_type === "CHECKBOX" ? (
                  <div className="mt-4">
                    <b>Options:</b>
                    <Row className="mx-0 px-1">
                      {question.options &&
                        question.options.length &&
                        question.options.map((option, idx) => {
                          const isCorrect =
                            question.correct_options &&
                            question.correct_options.some(
                              (c) => c.option_id == option.option_id
                            );
                          return (
                            <Col key={idx} className="my-2 d-flex align-items-center" md={6} sm={12}>
                              <input
                                type="checkbox"
                                checked={!!isCorrect}
                                disabled
                                readOnly
                                className="mr-2"
                              />
                              <span>{formatAlignText(option.text)}</span>
                            </Col>
                          );
                        })}
                    </Row>

                    {question.correct_options && question.correct_options.length ? (
                      <div className="my-3">
                        <b>Answer{question.correct_options.length > 1 ? "s" : ""}:</b>{" "}
                        {question.correct_options
                          .map((c) => formatAlignText(c.text))
                          .reduce((acc, cur, i) => (i === 0 ? [cur] : [...acc, ", ", cur]), [])}
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="my-3">
                      {question.source && getSourceStringfromQuestion(question) ? <b>Source: </b> :""}
                      {!question.isSourceRemoved
                        ? getSourceStringfromQuestion(question)
                        : "No source"}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                </div>
               

              
              </div>

              <hr className="my-2" />
            </div>


          );
        })}
      </ModalBody>
    </Modal>
  );
}
